import {
  RECORDING_REMOTE_TOOL_ACTION,
  useIsProjectRecordingAvailableCore,
} from '@heidi/agents/data';
import { getClientCapabilities } from './clientCapabilities';
const resolveRecordingAvailable = async () => {
  const caps = await getClientCapabilities({ advertiseRecordingRemoteTool: true });
  return caps?.remote_tools?.actions.includes(RECORDING_REMOTE_TOOL_ACTION) === true;
};
export const useIsProjectRecordingAvailable = () =>
  useIsProjectRecordingAvailableCore(resolveRecordingAvailable);
